import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import workImg from '../assets/images/work-img.png';
import robotImg from '../assets/images/robot.png';

const HowItWorks = () => {
    const { t } = useTranslation();
    const workSteps = [
        { id: '01', title: t('howitworks_step1_title'), desc: t('howitworks_step1_desc') },
        { id: '02', title: t('howitworks_step2_title'), desc: t('howitworks_step2_desc') },
        { id: '03', title: t('howitworks_step3_title'), desc: t('howitworks_step3_desc') },
    ];

    return (
        <section className="float-left w-100 position-relative main-box how-it-works-con padding-top padding-bottom">
            <Container className="wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                <Row>
                    <Col lg={7} md={12} className="wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.4s">
                        <div className="work-img-con position-relative">
                            <figure><img src={workImg} alt="how it works" className="img-fluid" /></figure>
                            <figure><img src={robotImg} alt="robot" className="img-fluid position-absolute robot-img animated-robot" /></figure>
                        </div>
                    </Col>
                    <Col lg={5} md={12} className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.4s">
                        <div className="work-content-con">
                            <div className="heading-title-con">
                                <span className="special-text color-blue d-block">{t('howitworks_title')}</span>
                                <h2>{t('howitworks_subtitle')}</h2>
                            </div>
                            <ul className="list-unstyled p-0">
                                {workSteps.map(step => (
                                    <li key={step.id} className="position-relative d-flex align-items-center">
                                        <span className="d-block color-blue">{step.id}</span>
                                        <div className="work-content-inner-con">
                                            <h5>{step.title}</h5>
                                            <p className="mb-0">{step.desc}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <a href="/about" className="text-decoration-none primary_btn d-inline-block">
                                {t('banner_get_started')}
                            </a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default HowItWorks;